/**
 * EventList
 */

import Config from '../Config';
import Util from '../Util';
import Search from './Search';
import Template from './Template';
import Loading from '../Loading';
import DropdownLayer from '../DropdownLayer';
import ParamInfo from './ParamInfo';
import ListCategory from './ListCategory';
import ListTopUtil from './ListTopUtil';
import NoticeList from './NoticeList';
import Promise from 'promise-polyfill';

class EventList {
  public onLoaded: any;

  private $node: any;

  private _id: string;

  private listId: string;

  private dateFormat: any;

  private isFirstLoaded: boolean;

  private loading: any;

  constructor(node: any, options: any) {
    this.$node = node;
    this.$node.addClass(Config.COMMUNITY_NODE);
    this._id = this.$node.attr('id');
    this.listId = 'ncCommunityBoardList';

    this.dateFormat = Util.dateFormat(Config);

    this.isFirstLoaded = false;

    jQuery.extend(true, Config, options);
    Config.board = options && options.board ? options.board : Config.board;
    Config.isCardView = options && options.isCardView ? options.isCardView : false;
    Config.isListView = options && options.isListView ? options.isListView : false;
    Config.site = options && options.site ? options.site : 'l2m';

    if (jQuery('html').attr('lang') === 'zh') {
      Config.site = `${Config.site}_TW`;
    } else if (jQuery('html').attr('lang') === 'en') {
      Config.site = `${Config.site}_SEA`;
    }

    Config.naviSize = options && options.naviSize ? options.naviSize : 5;

    // @TODO only status
    if (Config.board === 'eventlist_running' || options.status === 'RUNNING') {
      Config.status = 'RUNNING';
    }

    // @TODO only status
    if (Config.board === 'eventlist_closed' || options.status === 'CLOSED') {
      Config.status = 'CLOSED';
    }

    // @TODO 망별 구분
    Config.apiUrl = `${location.protocol}//${Util.net('.')}promotion.plaync.com/promo/api/promotion/v/2/page`;

    if (location.protocol === 'https:') {
      Config.apiUrl = `${location.protocol}//${Util.net('-')}promotion.plaync.com/promo/api/promotion/v/2/page`;
    }

    Config.apiUrl = options && options.apiUrl ? options.apiUrl : Config.apiUrl;

    // loadedComplete
    this.onLoaded = new Util.Observer();
  }

  public remove() {
    jQuery(`#${this._id} .${this.listId}`).empty();
    jQuery(`#${this._id} .pagination-container`).remove();
  }

  public get() {
    const _param = Util.getParams();
    const page = _param.page || 1;
    const category = _param.categoryId || 0;

    this.loading = new Loading(this.$node);
    this.loading.setUI();
    this.loading.show();

    let _data = {
      naviSize: Config.naviSize,
      pageSize: Config.listSize,
      game: Config.site,
      status: Config.status,
      page,
      category
    };

    const list = new Promise( ( resolve: any, reject: any ) => {
      jQuery.ajax({
        url: Config.apiUrl,
        method: 'GET',
        data: _data,
        cache: false,
        xhrFields: { withCredentials: true },
        success: ( _data ) => { resolve( _data ); },
        error: ( _data ) => { reject( _data ); },
        dataType: 'json',
        contentType: 'application/json',
      });
    });

    const list$ = Util.from(list);

    list$.subscribe(
      (data: any) => {
        let tmp = '';

        // empty listNode
        this.remove();

        // empty data
        if (data.data.length === 0 && !this.isFirstLoaded) {
          this.$node.append(Template.empty(this.listId, Config.L10N.list_none_article));
          this.loading.hide();
          this.onLoaded.emit();
          return;
        }

        const pageUI = this.templatePaging(data.paging);
        if (Config.isDefaultViewMode === 'card') {
          tmp = this.templateCard(data, this.listId);
        } else {
          tmp = this.templateList(data, this.listId);
        }

        // list template + page navigation
        tmp = Util.Tmpl.join(tmp, pageUI);

        // append template data
        this.$node.append(tmp);

        this.isFirstLoaded = true;

        if (Config.setLegacyEventDate > 0) {
          jQuery('[data-is-legacy="true"] a').attr('href', '#');
          jQuery('[data-is-legacy="true"] a').on('click', evt => {
            evt.preventDefault();
          });
        }

        this.loading.hide();

        this.onLoaded.emit();
      },
      () => {
        this.loading.hide();

        this.onLoaded.emit();
      }
    );
  }

  private isLegacyEndDate(_endDate: any) {
    if (Config.setLegacyEventDate <= 0 || Config.now === '') {
      return false;
    }

    const _now = +new Date(Config.now);
    const _end = +new Date(_endDate);
    const _calc = (_now - _end) / (60 * 60 * 24 * 1000);

    return _calc >= Config.setLegacyEventDate;
  }

  private templatePaging(_page: any) {
    const _param = Util.getParams();
    const _prev = _page.start - 1;
    const _next = _page.end + 1;
    const _start = _page.start;
    const _end = _page.end;
    const _cur = _page.current;
    const _last = _page.last;
    const _pageList = [];
    const _category = _param.categoryId ? `&categoryId=${_param.categoryId}` : ``;

    for (let idx = _start, len = _end; len >= idx; idx++) {
      _pageList.push(idx);
    }

    const tmp = Util.Tmpl.iterate({
      data: _pageList,
      template: (_v: any) => `${_v === _cur ? `<li class="current">${_v}</li>` : `<li><a href="${Config.listPage}?page=${_v}${_category}">${_v}</a></li>`}`
    });

    return Util.Tmpl.render({
      data: {
        page: tmp,
        prev: _prev,
        next: _next
      },
      template: (_v: any) => `
				<div class="pagination-container">
					<ul class="pagination-list">
						${_v.prev ? `<li class="prev"><a href="${Config.listPage}?page=${_v.prev}${_category}"><i class="fe-icon-paging-prev"></i></a></li>` : ``}
						${_v.page}
						${_last > _start && _last > _end ? `<li class="next"><a href="${Config.listPage}?page=${_v.next}${_category}"><i class="fe-icon-paging-next"></i></a></li>` : ``}
					</ul>
				</div>`
    });
  }

  private templateList(_data: any, _id: string) {
    const _list = Util.Tmpl.iterate({
      data: _data.data,
      template: (articleList: any) => {
        const _displayStart = articleList.displayStartDate;
        const _displayEnd = articleList.displayEndDate;
        let _start = this.dateFormat.printOnlyDate(articleList.startDate);
        let _end = this.dateFormat.printOnlyDate(articleList.endDate);

        _start = _displayStart ? _displayStart : _start;
        _end = _displayEnd ? _displayEnd : _end;

        return `
					<li class="board-items" data-articleid="${articleList.promotionId || ''}" data-is-legacy="${this.isLegacyEndDate(articleList.endDate)}">
					<div class="title">
						<a href="${articleList.url}" ${Config.isListLinkTargetBlank ? `target="_blank"` : ``}>${articleList.title}</a>
					</div>
					<div class="info">
						<span class="event-date">${_start} ~ ${_end}</span>
					</div>
					</li>`;
      }
    });

    return Util.Tmpl.render({
      data: _list,
      template: (list: string) => `<ul class="${_id} board-list-default board-list-event">${list}</ul>`
    });
  }

  private templateCard(_data: any, _id: string) {
    const _list = Util.Tmpl.iterate({
      data: _data.data,
      template: (articleList: any) => {
        const _displayStart = articleList.displayStartDate;
        const _displayEnd = articleList.displayEndDate;
        const _server = Config.serverName[articleList.category];
        let _start = this.dateFormat.printOnlyDate(articleList.startDate);
        let _end = this.dateFormat.printOnlyDate(articleList.endDate);
        _start = _displayStart ? _displayStart : _start;
        _end = _displayEnd ? _displayEnd : _end;

        return `
					<li class="board-items" data-articleid="${articleList.promotionId || ''}" data-is-legacy="${this.isLegacyEndDate(articleList.endDate)}">
					  <div class="board-items-thumb">
						<a href="${articleList.url}" ${Config.isListLinkTargetBlank ? `target="_blank"` : ``}><img src="${articleList.eventListSmallImgUrl}" alt=""></a>
					  </div>
					  <div class="board-items-contents">
						  <div class="title">
						  	${_server ? `<span class="category">${_server}</span>` : ``}
							<a href="${articleList.url}" ${Config.isListLinkTargetBlank ? `target="_blank"` : ``}>${articleList.title}</a>
						  </div>
						  <div class="desc">
							<a href="${articleList.url}" ${Config.isListLinkTargetBlank ? `target="_blank"` : ``}>${articleList.description}</a>
						  </div>
					  </div>
					  <div class="board-items-footer">
						<div class="info">
						  <span class="date">${_start} ~ ${_end}</span>
						</div>
					  </div>
					</li>`;
      }
    });

    return Util.Tmpl.render({
      data: _list,
      template: (list: string) => `<ul class="${_id} board-list-card">${list}</ul>`
    });
  }
}

export default EventList;
